import React from "react";
import { PanelAddAdCategory } from "../../../UI/AdCategories/Add/PanelAddCategory";

const AddAdCategory = () => {
  return (
    <div>
      <PanelAddAdCategory />
    </div>
  );
};

export default AddAdCategory;
